import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Fragment } from 'react';
import isNotValidationGroupError from '../../utils/isNotValidationGroupError';
import { useI18n } from '../../i18n';
export const ErrorList = (props)=>{
    const { errors } = props;
    const { t } = useI18n();
    const errorsArray = errors.flatMap((err)=>{
        const fatalErrors = err.$errors.filter((x)=>x.isFatal === true);
        if (isNotValidationGroupError(err)) {
            const label = err.$rcc.regvarMetadata.label;
            const rawErrorMessages = fatalErrors.map((x)=>({
                    message: t(x.message)
                })).toJS();
            const errorMessages = rawErrorMessages.map((errorMessage)=>{
                if (errorMessage.message.includes('%') && errorMessage.message.includes('{') && errorMessage.message.includes('}')) {
                    return {
                        message: t('Värdet är ej tillåtet')
                    };
                } else {
                    return errorMessage;
                }
            });
            return errorMessages.map((x)=>({
                    displayName: label,
                    message: x.message
                }));
        } else {
            if (fatalErrors.length > 0) {
                return fatalErrors.map((error)=>({
                        displayName: error.name,
                        message: error.message
                    }));
            }
        }
        return [];
    });
    const warningsArray = errors.flatMap((err)=>{
        const warnings = err.$errors.filter((x)=>x.isFatal === false);
        if (isNotValidationGroupError(err)) {
            const label = err.$rcc.regvarMetadata.label;
            const warningMessages = warnings.map((x)=>({
                    message: t(x.message)
                })).toJS();
            return warningMessages.map((x)=>({
                    displayName: label,
                    message: x.message
                }));
        } else {
            if (warnings.length > 0) {
                return warnings.map((warning)=>({
                        displayName: warning.name,
                        message: warning.message
                    }));
            }
        }
        return [];
    });
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            !!errorsArray.length && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("h3", {
                        children: "Fel:"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "review-grid",
                        children: errorsArray.map((error, i)=>/*#__PURE__*/ _jsxs(Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsx("label", {
                                        className: "form-label text-danger",
                                        children: error.displayName
                                    }),
                                    error.message
                                ]
                            }, i))
                    })
                ]
            }),
            !!warningsArray.length && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("h3", {
                        children: "Varningar:"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "review-grid",
                        children: warningsArray.map((error, i)=>/*#__PURE__*/ _jsxs(Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsx("label", {
                                        className: "form-label text-warning",
                                        children: error.displayName
                                    }),
                                    error.message
                                ]
                            }, i))
                    })
                ]
            })
        ]
    });
};
